import { Badge, type BadgeProps } from '@atlas/ui-primitives'
import { CAMPAIGN_STATUS_LABELS, CampaignStatus } from '@/domain/campaign.types'

export interface CampaignStatusBadgeProps {
	status: CampaignStatus
}

/**
 * The visual weight each lifecycle state carries. Exported because the row on a table and a
 * campaign handed to `CampaignListCard` have to read the same state the same way, and two
 * copies of this map would drift the first time a state was added.
 */
export const CAMPAIGN_STATUS_VARIANT: Record<CampaignStatus, NonNullable<BadgeProps['variant']>> = {
	[CampaignStatus.DRAFT]: 'muted',
	[CampaignStatus.IN_PROGRESS]: 'primary',
	[CampaignStatus.IN_REVIEW]: 'secondary',
	[CampaignStatus.APPROVED]: 'success',
	[CampaignStatus.LIVE]: 'success',
	[CampaignStatus.ARCHIVED]: 'danger',
}

/** Maps a Campaign status to its label and styling. The state is always conveyed by text as well as color. */
export function CampaignStatusBadge({ status }: CampaignStatusBadgeProps) {
	return <Badge variant={CAMPAIGN_STATUS_VARIANT[status]}>{CAMPAIGN_STATUS_LABELS[status]}</Badge>
}
